import React from "react";
import PropTypes from "prop-types";
import radium from "radium";
import Waypoint from "react-waypoint";
import colors from "backpack-ui/dist/styles/colors";
import { Heading } from "backpack-ui/dist/components/text";
import Ad from "backpack-ui/dist/components/ad";
import {
  fontSizeHeading3,
  fontSizeHeading4,
  fontSizeHeading5,
  fontSizeHeading6,
} from "backpack-ui/dist/styles/typography";
import mq from "backpack-ui/dist/styles/mq";
import WorldNomadsWidget from "../worldNomadsWidget";
import { generateTitleId } from "../../utils/generateTitleId";

const styles = {
  section: {
    marginBottom: "40px",

    [`@media (min-width: ${mq.min["960"]})`]: {
      marginBottom: "80px",
    },
  },
  adContainer: {
    marginBottom: "56px",
    minHeight: "296px",

    [`@media (min-width: ${mq.min["960"]})`]: {
      marginBottom: "120px",
    },
  },
  mainSection: {
    marginBottom: "64px",
    [`@media (min-width: ${mq.min["960"]})`]: {
      marginBottom: "112px",
    },
  },
  title: {
    level0: {
      fontSize: `${fontSizeHeading4}px`,
      marginBottom: `${fontSizeHeading3}px`,
      [`@media (max-width: ${mq.max["768"]})`]: {
        backgroundColor: colors.bgPrimary,
        paddingTop: "24px",
      },

      [`@media (min-width: ${mq.min["960"]})`]: {
        fontSize: `${fontSizeHeading3}px`,
      },
    },
    level1: {
      fontSize: `${fontSizeHeading6}px`,
      marginBottom: "28px",
      [`@media (min-width: ${mq.min["960"]})`]: {
        fontSize: `${fontSizeHeading5}px`,
        marginBottom: "1em",
      },
    },

    level2: {
      marginBottom: 0,
      [`@media (min-width: ${mq.min["960"]})`]: {
        fontSize: `${fontSizeHeading6}px`,
        marginBottom: "1em",
      },
    },

    level3: {
      marginBottom: 0,
      marginTop: "1em",

      [`@media (min-width: ${mq.min["960"]})`]: {
        fontSize: `${fontSizeHeading6}px`,
        marginBottom: "1em",
      },
    },
    level4: {
      marginBottom: 0,
      marginTop: "1em",

      [`@media (min-width: ${mq.min["960"]})`]: {
        fontSize: `${fontSizeHeading6}px`,
        marginBottom: "1em",
      },
    },
  },
};

const headingSizes = {
  0: 6,
  1: 7,
  2: 8,
  3: 8,
};

const NarrativeContentSection = ({
  title,
  id,
  index,
  isFirstSection,
  setActiveLink,
  topLevelSections,
  subsections,
  text,
  level,
  style,
  className,
}) => {
  const onWaypointEnter = (wayId, wayTitle) => {
    setActiveLink(wayId, wayTitle);
  };

  // return what number section this section is starting at 1
  // needed for id for ads
  const topLevelSectionOrder = () => topLevelSections.findIndex(i => i.title === title) + 1;

  // Don't show on first section
  // Show every 3 sections
  // Don't show any after 4 ads (less then the 13th seciton)
  const shouldShowAd = level === 0 && !isFirstSection && (index && index % 3 === 0) && index < 13;

  return (
    <section
      id={level === 0 ? id : null}
      style={[text.length === 0 && styles.section, level === 0 && styles.mainSection, style]}
      className={className}
      data-swiftype-name="body" data-swiftype-type="text"
    >
      {level === 0 && (
        <Waypoint
          onEnter={() => {
            onWaypointEnter(id, title);
          }}
          bottomOffset="90%"
          fireOnRapidScroll
        />
      )}

      {shouldShowAd && (
        <Ad
          framed
          id={`ad-expansion-in-content-${id}-${topLevelSectionOrder()}`}
          style={styles.adContainer}
        />
      )}

      <Heading
        level={level + 2}
        size={headingSizes[level]}
        weight={level === 1 ? "regular" : "medium"}
        style={[styles.title[`level${level}`]]}
      >
        {title}
      </Heading>

      {text.length !== 0 && (
        <div className="NarrativeBodyText" dangerouslySetInnerHTML={{ __html: text }} />
      )}

      {title.toLowerCase() === "insurance" && level === 0 && <WorldNomadsWidget />}
      {subsections &&
        subsections.map(i => (
          <NarrativeContentSection
            id={generateTitleId(`${title}-${i.title}`)}
            key={i.title}
            {...i}
          />
        ))}
    </section>
  );
};

NarrativeContentSection.propTypes = {
  title: PropTypes.string,
  id: PropTypes.string,
  isFirstSection: PropTypes.bool,
  subsections: PropTypes.array,
  setActiveLink: PropTypes.func,
  text: PropTypes.string,
  level: PropTypes.number,
  index: PropTypes.number,
  topLevelSections: PropTypes.array,
  style: PropTypes.string,
  className: PropTypes.string,
};

export default radium(NarrativeContentSection);



// WEBPACK FOOTER //
// ./assets/pois/components/narrativeContentSection/index.jsx